/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rmf_Banner_RetryInputs */

const en_rmf_banner_retry = /** @type {(inputs: Rmf_Banner_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`retry`)
};

const fr_rmf_banner_retry = /** @type {(inputs: Rmf_Banner_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`réessayer`)
};

const ms_sg2_rmf_banner_retry = /** @type {(inputs: Rmf_Banner_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cuba semula`)
};

/**
* | output |
* | --- |
* | "retry" |
*
* @param {Rmf_Banner_RetryInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const rmf_banner_retry = /** @type {((inputs?: Rmf_Banner_RetryInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rmf_Banner_RetryInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rmf_banner_retry(inputs)
	if (locale === "fr") return fr_rmf_banner_retry(inputs)
	return ms_sg2_rmf_banner_retry(inputs)
});